import {useQuery} from '@tanstack/react-query';
import {secondsToMilliseconds} from 'app/util/timeConverter';

import {Payment, PaymentApi, paymentMapper} from '../index';

interface Options<TData, TSelect = TData> {
  enabled?: boolean;
  select?: (data: TData) => TSelect;
}

export function usePaymentQuery<TSelect = Payment.Metadata>(
  teamId: string,
  options: Options<Payment.Metadata, TSelect> = {},
) {
  return useQuery({
    queryKey: ['payment', teamId],
    queryFn: async () => {
      const res = await PaymentApi.getPayment(teamId);
      return paymentMapper.mapPayment(res);
    },
    refetchInterval: secondsToMilliseconds(30),
    ...options,
  });
}
